import Vue from 'vue';
import formatDate from '@filters/formatDate';
import formatBoolean from '@filters/formatBoolean';
import formatFullDate from '@filters/formatFullDate';

Vue.filter('formatDate', formatDate);
Vue.filter('formatBoolean', formatBoolean);
Vue.filter('formatFullDate', formatFullDate);
